import { Component, OnInit, ViewEncapsulation } from '@angular/core';

interface IconWallIcon {
  svg: string;
  alt: string;
  title: string;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-icon-wall',
  styleUrls: ['./icon-wall.component.scss'],
  templateUrl: './icon-wall.component.html'
})
export class IconWallComponent implements OnInit {
  icons: IconWallIcon[] = [
    { alt: '', svg: 'assets/home/icon-wall/lattitude-logo-v3.svg', title: 'L’ATTITUDE' },
    { alt: '', svg: 'assets/home/icon-wall/precursor-ventures-logo-v2.svg', title: 'Precursor Ventures' },
    { alt: '', svg: 'assets/home/icon-wall/1517-logo-v2.svg', title: '1517' },
    { alt: '', svg: 'assets/home/icon-wall/upwest-logo-v2.svg', title: 'Upwest' },
    { alt: '', svg: 'assets/home/icon-wall/quiet-capital-logo-v2.svg', title: 'Quiet Capital' },
    { alt: '', svg: 'assets/home/icon-wall/susa-ventures-logo-v2.svg', title: 'Susa Ventures' },
    { alt: '', svg: 'assets/home/icon-wall/k5-ventures-logo-v3.svg', title: 'K5 Ventures' },
  ];

  mobileIcons: IconWallIcon[] = [
    { alt: '', svg: 'assets/home/icon-wall/lattitude-logo-v3.svg', title: 'L’ATTITUDE' },
    { alt: '', svg: 'assets/home/icon-wall/1517-logo-v2.svg', title: '1517' },
    { alt: '', svg: 'assets/home/icon-wall/precursor-ventures-logo-v2.svg', title: 'Precursor Ventures' },
    { alt: '', svg: 'assets/home/icon-wall/quiet-capital-logo-v2.svg', title: 'Quiet Capital' },
    { alt: '', svg: 'assets/home/icon-wall/upwest-logo-v2.svg', title: 'Upwest' },
    { alt: '', svg: 'assets/home/icon-wall/susa-ventures-logo-v2.svg', title: 'Susa Ventures' },
    { alt: '', svg: 'assets/home/icon-wall/k5-ventures-logo-v3.svg', title: 'K5 Ventures' },
  ];

  constructor() {}

  ngOnInit(): void {}
}
